/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpRespBuyerAssuranceBox_user$ref = any;
type PdpRespDealerDetails_user$ref = any;
type PdpRespHeroCarousel_user$ref = any;
type PdpRespIconBubblesWrapper_user$ref = any;
type PdpRespShippingReturns_user$ref = any;
type PdpRespSidebarBlurbs_user$ref = any;
type PdpRespSidebarButtons_user$ref = any;
type PdpRespSidebarContact_user$ref = any;
type PdpRespSidebarSellerInfo_user$ref = any;
type PdpRespSimilarItemsFooter_user$ref = any;
type PdpRespSimilarItemsGridSeller_user$ref = any;
type PdpRespSwatchSelector_user$ref = any;
type PdpSharedDescriptionAdditionalOptions_user$ref = any;
type PdpSharedPromoCode_user$ref = any;
type PdpSharedTradeRewardsBenefitCardLoader_user$ref = any;
type SharedRecentlyViewedItems_user$ref = any;
type SuspectedTradeUserLoader_user$ref = any;
export type PdpRespContainer_user$ref = any;
export type PdpRespContainer_user = {
    readonly " $fragmentRefs": PdpRespSimilarItemsGridSeller_user$ref & PdpRespSimilarItemsFooter_user$ref & PdpRespSidebarButtons_user$ref & PdpRespSidebarBlurbs_user$ref & PdpRespShippingReturns_user$ref & PdpRespBuyerAssuranceBox_user$ref & PdpRespSidebarContact_user$ref & PdpRespHeroCarousel_user$ref & PdpRespIconBubblesWrapper_user$ref & PdpRespDealerDetails_user$ref & PdpRespSidebarSellerInfo_user$ref & PdpSharedPromoCode_user$ref & PdpSharedTradeRewardsBenefitCardLoader_user$ref & PdpRespSwatchSelector_user$ref & SharedRecentlyViewedItems_user$ref & SuspectedTradeUserLoader_user$ref & PdpSharedDescriptionAdditionalOptions_user$ref;
    readonly " $refType": PdpRespContainer_user$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMultiSku",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsGridSeller_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsFooter_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarButtons_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespShippingReturns_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespBuyerAssuranceBox_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarContact_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespHeroCarousel_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubblesWrapper_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespDealerDetails_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarSellerInfo_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedPromoCode_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedTradeRewardsBenefitCardLoader_user",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isMultiSku",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "PdpRespSwatchSelector_user",
          "args": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SharedRecentlyViewedItems_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SuspectedTradeUserLoader_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDescriptionAdditionalOptions_user",
      "args": null
    }
  ]
};
(node as any).hash = 'eb6f5d70cc7dbd1da52e9ec2e1db26c2';
export default node;
